import { render, staticRenderFns } from "./finvoice.vue?vue&type=template&id=4ecf0c60&scoped=true&"
import script from "./finvoice.vue?vue&type=script&lang=js&"
export * from "./finvoice.vue?vue&type=script&lang=js&"
import style0 from "./finvoice.vue?vue&type=style&index=0&id=4ecf0c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf0c60",
  null
  
)

export default component.exports